import React from 'react';

import SmartImage from 'dpl/components/SmartImage';
import DogPlaceholderSvg from 'dpl/common/components/DogPlaceholderSvg';

import useInitialInquiry from '../hooks/useInitialInquiry';

const IMAGE_SIZE = '72px';

export default function PuppyInfo() {
  const { currentPuppy } = useInitialInquiry();

  const {
    name: puppyName,
    profile_photo_url: puppyProfilePhotoUrl,
    ready_for_adoption_date_description: availabilityDescription
  } = currentPuppy;

  return (
    <div className="PuppyInfo flex flex-column items-center justify-center tc mt10">
      {puppyProfilePhotoUrl ? (
        <SmartImage
          Tag="div"
          width={IMAGE_SIZE}
          height={IMAGE_SIZE}
          lazy
          className="bg-center cover h-100 w-100 br-100"
          loadingClass="bg-light-gray br-100"
          src={puppyProfilePhotoUrl}
        />
      ) : (
        <DogPlaceholderSvg
          width={IMAGE_SIZE}
          height={IMAGE_SIZE}
          puppy
          className="bg-light-gray br-100"
        />
      )}
      <div className="mt5">
        <p className="f4 dark-gray">
          {puppyName} | {availabilityDescription}
        </p>
      </div>
    </div>
  );
}
